import type { ButtonProps } from '@creator/ui/components/Button/ButtonV2';
import ConfirmModalLib, { type ConfirmModalProps as ConfirmModalLibProps } from '@creator/ui/components/ConfirmModal/ConfirmModal';
import { mergeProps } from '@creator/ui/utils/merge-props/merge-props';
import { ModalContext } from '@src/context/modal-context';
import type { UseModal } from '@src/hooks/use-modal';
import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

export interface ConfirmModalProps {
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    className?: string;
    title: string;
    subtitle?: string;
    okButtonProps: ButtonProps;
    cancelButtonProps?: ButtonProps;
    children?: React.ReactNode;
}

const ConfirmModal: FC<ConfirmModalProps> = props => {
    const { t } = useTranslation();

    const { handleModal } = useContext<UseModal>(ModalContext);

    function renderContent() {
        const { cancelButtonProps = {} } = props;

        const _props = mergeProps<[Partial<ConfirmModalLibProps>, ConfirmModalLibProps]>(
            {
                okButtonText: t('confirmModal.okButton'),
                cancelButtonText: t('confirmModal.cancelButton'),
            },
            props
        );

        const _cancelButtonProps = mergeProps(
            {
                onClick: () => handleModal(null),
            },
            cancelButtonProps
        );

        _props.cancelButtonProps = _cancelButtonProps;

        return <ConfirmModalLib {..._props} />;
    }

    return renderContent();
};

export default ConfirmModal;
